/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Form } from '@jalik/react-form'
import { FormattedMessage, useIntl } from 'react-intl'
import AppVersion from '../../../client/js/components/AppVersion'
import ButtonGroup from '../../../client/js/components/form/ButtonGroup'
import FormField from '../../../client/js/components/form/fields/FormField'
import FormSubmitButton from '../../../client/js/components/form/buttons/FormSubmitButton'
import PageTitle from '../../../client/js/components/PageTitle'
import {
  createFieldInitializer,
  createFieldValidator,
  createFormValidator
} from '../../../client/js/lib/form'
import { useAuthContext } from '../components/AuthProvider'
import SignInFormSchema from '../schemas/SignInFormSchema.mjs'
import { useNavigate } from 'react-router'
import useParsedQueryParam from '../../../client/js/hooks/useParsedQueryParam'
import { getPasswordResetLink } from '../../user/lib/passwordLinks'
import { Box, Card, PasswordInput, Stack, Text } from '@mantine/core'
import AnchorLink from '../../../client/js/components/AnchorLink'
import FormErrorAlert from '../../../client/js/components/form/FormErrorAlert'
import useCustomForm from '../../../client/js/hooks/useCustomForm'
import Page from '../../../client/js/components/Page'
import { useEffect } from 'react'

function SignInPage () {
  const intl = useIntl()
  const redirect = useParsedQueryParam('redirect', String)
  const navigate = useNavigate()
  const { signIn } = useAuthContext()

  const form = useCustomForm({
    initialValues: {
      username: '',
      password: ''
    },
    initializeField: createFieldInitializer(SignInFormSchema),
    validateField: createFieldValidator(SignInFormSchema),
    validate: createFormValidator(SignInFormSchema),
    onSubmit: (values) => {
      const { username, password } = values
      return signIn(username, password)
    },
    onSuccess () {
      // fixme redirect not working (only in useEffect)
      navigate(redirect || '/admin')
    }
  })

  useEffect(() => {
    if (form.submitted) {
      navigate(redirect || '/admin')
    }
  }, [form.submitted, navigate, redirect])

  return (
    <Page>
      <Stack w="100%" maw={450}>
        <Card shadow="sm" p="xl">
          <Form context={form}>
            <Stack>
              <PageTitle
                size="h2"
                title={intl.formatMessage({
                  id: 'authentication',
                  defaultMessage: 'Authentification'
                })}
              />

              <FormErrorAlert />

              <FormField
                label={intl.formatMessage({
                  id: 'identifier',
                  defaultMessage: 'Identifiant'
                })}
                name="username"
              />
              <Box>
                <FormField
                  label={intl.formatMessage({
                    id: 'password',
                    defaultMessage: 'Mot de passe'
                  })}
                  name="password"
                  render={PasswordInput}
                />
                <AnchorLink
                  to={getPasswordResetLink()}
                  size="sm"
                >
                  <FormattedMessage
                    id="password_forgotten"
                    defaultMessage="Mot de passe oublié"
                  />
                </AnchorLink>
              </Box>

              <ButtonGroup>
                <FormSubmitButton
                  fullWidth
                  size="lg"
                  label={intl.formatMessage({
                    id: 'sign_in',
                    defaultMessage: 'Se connecter'
                  })}
                />
              </ButtonGroup>
            </Stack>
          </Form>
        </Card>
        <Text ta="center">
          <AppVersion />
        </Text>
      </Stack>
    </Page>
  )
}

export default SignInPage
